import { AxisSwitcher, BorderGridContainer, GridBox, Section, Wrapper } from '@ahmdigital/ui';
import { capitalize, lowerCase } from 'lodash/fp';
import React from 'react';

import Services from './components/services';
import type { Services as ServicesProps } from '../../types';

const colorGreen = '#0a5';
const colorRed = '#ff2828';

type Props = {
  excludedServices: Readonly<ServicesProps>;
  includedServices: Readonly<ServicesProps>;
  name: string;
};

const InclusionsExclusions = ({ excludedServices, includedServices, name }: Props) => (
  <BorderGridContainer hideBorderTop>
    <GridBox padding="1rem">
      <Section>
        <Wrapper>
          <AxisSwitcher limit={2} space="2rem" threshold="32rem">
            <Services
              iconProps={{ fill: colorGreen, icon: 'tick-circle' }}
              heading={`${capitalize(name)} includes:`}
              {...includedServices}
            />
            <Services
              iconProps={{ fill: colorRed, icon: 'cross-circle' }}
              heading={`Not included in ${lowerCase(name)}:`}
              {...excludedServices}
            />
          </AxisSwitcher>
        </Wrapper>
      </Section>
    </GridBox>
  </BorderGridContainer>
);

export default InclusionsExclusions;
